import { render, staticRenderFns } from "./myMaterial.vue?vue&type=template&id=f37457d2&scoped=true&"
import script from "./myMaterial.vue?vue&type=script&lang=js&"
export * from "./myMaterial.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/material/myMaterial.less?vue&type=style&index=0&id=f37457d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37457d2",
  null
  
)

component.options.__file = "myMaterial.vue"
export default component.exports